import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { formatRequestMail } from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { Tools } from '@service/tools';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormBase } from '@core/_classes/form.base';
import { Message } from 'primeng/api';
import { EmailCtrl } from '../_const/const';
import { RightService } from '@service/right.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'senddocsmail',
    templateUrl: 'senddocsmail.component.html',
    styleUrls: ['senddocsmail.component.scss'],
})
export class SendDocsMailComponent extends FormBase implements OnInit, OnChanges {
    @Input() public selectedDocs;
    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    public mailForm: FormGroup;
    public fr: any;
    public error = false;
    public errorMessage = '';
    public addAtf = false;

    constructor(
        private formBuilder: FormBuilder,
        private api: ApiV6Service,
        public tools: Tools,
        protected _messageService: MessagesService,
        private rightService: RightService,
        private translate: TranslateService
    ) {
        super(_messageService);
        this.mailForm = this.formBuilder.group({
            mailTo: [null, [Validators.required, Validators.pattern(EmailCtrl)]],
            mailCc: [null, [Validators.pattern(EmailCtrl)]],
            mailCci: [null, [Validators.pattern(EmailCtrl)]],
            mailSubject: null,
            mailMsg: null,
            mailZip: null,
            mailAddAtf: null,
        });
        this.initialization();
    }

    public ngOnInit() {
        this.init();
    }

    public ngOnChanges() {
        this.init();
    }

    public onClickSendMail() {
        const error: Array<Message> = [];
        if (this.mailForm.invalid) {
            this.getErrorsInputs(error, this.mailForm);
        } else {
            this.prepareList(this.selectedDocs);
        }
    }

    private prepareList(aSelectedDocs) {
        let wDocList = new Array();
        wDocList = this.rightService.verifyRight(aSelectedDocs, 'TMail');

        if (wDocList.length === 0) {
            this._messageService.addWarnNoStick(this.translate.instant('NoSend_Right'));
            this.close(null);
        } else {
            this.execSendMail(this.mailForm.value, wDocList, aSelectedDocs.length - wDocList.length);
        }
    }

    private async execSendMail(aData, wDocList, aNbdoc) {
        let wRes: any;
        const wParams = formatRequestMail(aData, wDocList);

        try {
            wRes = await lastValueFrom(this.api.execUrlAction('senddocmail', wParams));
            if (aNbdoc === 0) {
                this._messageService.addSuccess(this.translate.instant('Send_OK'));
            } else {
                this._messageService.addWarnNoStick(this.translate.instant('Send_Right'));
            }
            this.close(null);
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Send_KO'));
        }
    }

    public close(event) {
        this.visible = false;
        this.onClose.emit();
    }

    private init() {
        this.mailForm.patchValue({
            mailTo: null,
            mailCc: null,
            mailCci: null,
            mailSubject: null,
            mailMsg: null,
            mailZip: null,
            mailAddAtf: null,
        });
        this.addAtf = this.selectedDocs.length === 1;
    }

    private initialization() {
        this.keys = {
            mailTo: {
                label: this.translate.instant('UsersD_1'),
                pattern: '',
            },
            mailCc: {
                label: this.translate.instant('Field_Cc'),
                pattern: '',
            },
            mailCci: {
                label: this.translate.instant('Field_Cci'),
                pattern: '',
            },
        };
    }
}
